import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import CertificateInfoCard from './CertificateInfoCard';

import { CertificateSubmission } from '../../model';

interface CertificatesForNewAssetsSectionProps {
  submission: CertificateSubmission;
}

const CertificatesForNewAssetsSection: React.FC<CertificatesForNewAssetsSectionProps> = (props) => {
  const { submission } = props;

  return (
    <Grid container spacing={2} style={{ padding: '1% 2%' }}>
      <Typography variant="h5" style={{ marginTop: 20 }}>
        Certificates for New Assets
      </Typography>
      {submission.ahri_certificates?.length > 0 ? (
        <Grid container spacing={2}>
          {submission.ahri_certificates?.map((certificate) => (
            <Grid item xs={12} key={`cert-${certificate.id}`}>
              <CertificateInfoCard certificate={certificate} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 120 }}>
          <Grid item>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{
                textAlign: 'center',
                fontStyle: 'italic',
                opacity: 0.7,
              }}
            >
              No AHRI certificates have been added to this submission yet
            </Typography>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default CertificatesForNewAssetsSection;
